export default __webpack_public_path__ + "static/media/product-image-23.9e8e5878.jpg";